import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone';
import { userProfileService } from '../../services/backoffice/userProfile.service'
import './users.scss'
import swal from "sweetalert"
import { useSelector } from 'react-redux';

export function BulkLoad() {
    const companyId = useSelector(state => state.userSettings.companyId)
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ multiple: false });
    const [validationErrors, setValidationErrors] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const upload = async () => {
        if (acceptedFiles.length === 0) {
            swal({ text: "Debes cargar un archivo para continuar", icon: "warning" });
            return;
        }

        setIsLoading(true);
        setValidationErrors(null);

        try {
            const result = await userProfileService.uploadMigrationFile(companyId, acceptedFiles[0]);
            if (result.responseCode === "00") {
                swal({ 
                    text: result.responseMessage, 
                    icon: "success" 
                }).then(() => {
                    window.location.href = "/users";
                });
            } else {
                if (result.data) {
                    setValidationErrors(result.data);
                } else {
                    swal({ text: "Error al procesar archivo", icon: "error" });
                }
            }
        } catch (error) {
            console.error("Upload error:", error);
            swal({ text: "Error al subir el archivo", icon: "error" });
        } finally {
            setIsLoading(false);
        }
    }

    const clearErrors = () => {
        setValidationErrors(null);
    }

    return (
        <section className="wrapper_users_details padd">
            <div className="mb-4 divtop">
                <div className="box_ttl_opt no_reverse mb-1 ">
                    <div>
                        <h2 className="mb-0 text fnt_medium">Usuario</h2>
                        <h6 className="text-muted">Carga masiva</h6>
                    </div>
                    <div className="box_actions">
                        <a className="btn secundary mr-2" href="https://storagervadmindev.blob.core.windows.net/ctnprimecontentmx/Common/TemplateUser.csv">
                            <i className="far fa-file-excel"></i> Descargar template
                        </a>
                    </div>
                </div>
            </div>
            
            <div className="wrapper_dropzone">
                <div {...getRootProps({ className: 'dropzone shadows bradius' })}>
                    <input {...getInputProps()} accept=".csv" />
                    <div className="box_dropzone">
                        <span><i className="fas fa-download"></i></span>
                        <p>Arrastre y suelte un archivo .csv aquí, o haga clic para seleccionar un archivo.</p>
                    </div>
                </div>
                <aside className="mt-4">
                    <h5 className="text fnt_medium">Archivo seleccionado:</h5>
                    <ul>{files}</ul>
				</aside>
				 {validationErrors && (
                <div className="bulk-load-container mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-danger">
                            <i className="fas fa-exclamation-triangle"></i> Errores de Validación
                        </h4>
                        <button className="btn btn-outline-danger btn-sm" onClick={clearErrors}>
                            <i className="fas fa-times"></i> Ocultar
                        </button>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <strong>Total registros:</strong> {validationErrors.summary?.totalRegistros || 'N/A'}
                                </div>
                                <div className="col-md-3">
                                    <strong>Total errores:</strong> {validationErrors.totalErrors || 'N/A'}
                                </div>
                                <div className="col-md-3">
                                    <strong>Errores en headers:</strong> {validationErrors.summary?.erroresHeaders || 'N/A'}
                                </div>
                                <div className="col-md-3">
                                    <strong>Errores en registros:</strong> {validationErrors.summary?.erroresRegistros || 'N/A'}
                                </div>
                            </div>

                            {/* Tabla de errores*/}
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-sm">
                                    <thead >
                                        <tr>
                                            <th>Fila</th>
                                            <th>Campo</th>
                                            <th>Error</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {validationErrors.errorsByType && 
                                         Object.entries(validationErrors.errorsByType).flatMap(([type, errors]) =>
                                            errors && Array.isArray(errors) ? errors.map((error, index) => (
                                                <tr key={`${type}-${index}`}>
                                                    <td>{error?.rowNumber || 'N/A'}</td>
                                                    <td>{error?.field || 'N/A'}</td>
                                                    <td className="text-danger">{error?.errorMessage || 'N/A'}</td>
                                                    <td>
                                                        <code>{error?.value || 'N/A'}</code>
                                                    </td>
                                                </tr>
                                            )) : []
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
                <hr />
                <div className="text-right">
                    <button 
                        onClick={upload} 
                        className="btn primary"
                        disabled={isLoading}>
                        {isLoading ? 'Procesando...' : 'Subir archivo'}
                    </button>
                </div>
            </div>
        </section>
    )
}